// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__c6VHh","border":"style_border__k7cDu","none":"style_none__I5KBm"};